export default __webpack_public_path__ + "static/media/flag-tubalu.92c1280a.svg";